import React from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import type { RootState } from '../store/store';
import { useSelector } from 'react-redux';

interface ThemeWrapperProps {
  children: React.ReactNode;
}

export const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
  const currentTheme = useSelector((state: RootState) => state.auth.theme);

  return (
    <ConfigProvider
      theme={{
        algorithm: currentTheme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: '#D4920B',
          borderRadius: 8,
          colorBgContainer: currentTheme === 'dark' ? '#1C1A18' : '#FBF7F0',
          colorBgLayout: currentTheme === 'dark' ? '#1C1A18' : '#FBF7F0',
          colorBgElevated: currentTheme === 'dark' ? '#24211D' : '#FFFFFF',
          colorBorder: currentTheme === 'dark' ? '#3A3630' : '#DDD8CF',
          colorText: currentTheme === 'dark' ? '#F5F2ED' : '#2C2A27',
          colorTextSecondary: currentTheme === 'dark' ? '#C5C1BA' : '#4A4844',
        },
      }}
    >
      <div
        style={{
          background: currentTheme === 'dark' ? '#1C1A18' : '#FBF7F0',
          minHeight: '100vh',
          width: '100%',
        }}
      >
        {children}
      </div>
    </ConfigProvider>
  );
};
